// extracted by mini-css-extract-plugin
export default {"container":"skill-card_container__cdqmO","tag":"skill-card_tag__BKoMU"};